/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    "use strict";

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                // Nav color
                $(window).scroll(function () {
                    if (window.matchMedia('(min-width: 1199px)').matches) {
                        if ($(document).scrollTop() > 100) {
                            $('nav').addClass('nav-scroll');
                        } else {
                            $('nav').removeClass('nav-scroll');
                        }
                    }
                });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

                $(document).ready(function () {
                    $('#nav-icon').click(function () {
                        $(this).toggleClass('open');
                    });
                });

                // Slider header
                $('.slider-homepage').slick({
                    arrows: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: false
                            }
                        }
                    ]
                });

                // Slider actu homepage
                $('.slider-actu').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                centerMode: true,
                                focusOnSelect: true,
                                // centerPadding: '40px',
                                slidesToShow: 1,
                                arrows: false
                            }
                        }
                    ]
                });

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        },
        // page archive des references
        'nos_references': {
            init: function () {

                $(window).load(function () {

                    $(window).resize(function () {
                        $container.isotope('layout');
                    });

                    var $container = $('.grid');
// initialize Isotope
                    $container.isotope({
                        percentPosition: true,
                        masonry: {
                            columnWidth: '.grid-sizer'
                        }
                    });


// filtering :
                    $('.rubriques button').click(function () {
                        var $rub = $(this).data('slug');
                        if ($rub !== '*') {
                            $rub = '.' + $rub;
                        }
                        $container.isotope({filter: $rub});
                        console.log($rub)
                    });

                    //shuffle ref
                    var $grid = $('.grid').isotope({
                        getSortData: {
                            name: '.name', // text from querySelector
                            category: '[data-category]', // value of attribute
                            weight: function (itemElem) { // function
                                var weight = $(itemElem).find('.weight').text();
                                return parseFloat(weight.replace(/[\(\)]/g, ''));
                            }
                        }
                    });
                    $grid.isotope({sortBy: 'random'});
                    // init Isotope
                    var $grid = $('.grid').isotope({
                        // options...
                    });
// layout Isotope after each image loads
                    $grid.imagesLoaded().progress(function () {
                        $grid.isotope('layout');
                    });
                });


                // JavaScript to be fired
                // var Shuffle = window.Shuffle;
                // var element = document.querySelector('.my-shuffle');
                //
                // var shuffleInstance = new Shuffle(element, {
                //     itemSelector: '.my-item',
                //     sizer: '.my-sizer-element',
                //     buffer: 1,
                // });
                $(document).ready(function(){
                    $('ul li button').click(function(){
                        $('li button').removeClass("activebis");
                        $(this).addClass("activebis");
                    });
                });
            }
        }
    };

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    //anchors
    $(document).ready(function () {
        $('a[href^="#"]').on('click', function () {
            var target = this.hash,
                $target = $(target);
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - ($('.navbar').height() + 50)
            });
        });
    });

    //active
    $('ul li.active a').attr('class', 'active');
// Load Events
    $(document).ready(UTIL.loadEvents);

    //placeholder
    jQuery(document).ready(function () {

        jQuery.fn.cleardefault = function () {
            return this.focus(function () {
                if (this.value === this.defaultValue) {
                    this.value = "";
                }
            }).blur(function () {
                if (!this.value.length) {
                    this.value = this.defaultValue;
                }
            });
        };
        jQuery(".formu_contact input, .formu_contact textarea").cleardefault();
    });

    jQuery.validator.setDefaults({
        debug: true,
        success: "valid"
    });
    $("#gform_fields_1").validate({
        rules: {
            input_1_4: {
                required: true
            }
        }
    });

})(jQuery); // Fully reference jQuery after this point.
